import React from 'react';
import pt from 'prop-types';
import { SkeletonTheme } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const BASE_COLOR = '#e5e5e5';
const HIGHLIGHT_COLOR = '#ededed';
const DURATION = 6;

export default class SkeletonWrapper extends React.PureComponent {
  static propTypes = {
    className: pt.string,
    theme: pt.object,
    children: pt.node,
  };

  render() {
    const { theme, children } = this.props;

    return (
      <SkeletonTheme
        baseColor={BASE_COLOR}
        highlightColor={HIGHLIGHT_COLOR}
        duration={DURATION}
        inline
        {...theme}
      >
        {children}
      </SkeletonTheme>
    );
  }
}
